import { call, put } from "redux-saga/effects";

import * as api from "../../api/TdsApi";
import * as types from "../../constants/actionTypes";
import { createErrorMessageAction } from "../../utils/TypescriptUtils";
import { fetchTasks } from "../actions/MyTopologiesActions";

export function* resetTaskSaga(action) {
  try {
    const response = yield call(api.resetTask, action.taskId, action.environment);
    yield put({ type: types.RESET_TASK_SUCCESS, response });
    yield put(fetchTasks(action.machineName, action.topologyId, action.environment));
  } catch (error) {
    yield put(createErrorMessageAction(types.RESET_TASK_ERROR, error));
  }
}

export function* skipTaskSaga(action) {
  try {
    const response = yield call(api.skipTask, action.taskId, action.environment);
    yield put({ type: types.SKIP_TASK_SUCCESS, response });
    yield put(fetchTasks(action.machineName, action.topologyId, action.environment));
  } catch (error) {
    yield put(createErrorMessageAction(types.SKIP_TASK_ERROR, error));
  }
}

export function* pauseTaskSaga(action) {
  try {
    const response = yield call(api.pauseTask, action.taskId, action.isTaskPaused, action.environment);
    yield put({ type: types.PAUSE_TASK_SUCCESS, response });
    yield put(fetchTasks(action.machineName, action.topologyId, action.environment));
  } catch (error) {
    yield put(createErrorMessageAction(types.PAUSE_TASK_ERROR, error));
  }
}

export function* getTaskLogsSaga(action) {
  try {
    const taskLogs = yield call(api.getTaskLogs, action.taskId, action.environment);
    yield put({ type: types.FETCH_TASK_LOGS_SUCCESS, taskLogs });
  } catch (error) {
    yield put(createErrorMessageAction(types.FETCH_TASK_LOGS_ERROR, error));
  }
}

export function* getPropertyBagSaga(action) {
  try {
    const propertyBag = yield call(api.getPropertyBag, action.taskId, action.environment);
    yield put({ type: types.FETCH_PROPERTY_BAG_SUCCESS, propertyBag });
  } catch (error) {
    yield put(createErrorMessageAction(types.FETCH_PROPERTY_BAG_ERROR, error));
  }
}

export function* uploadPropertyBagSaga(action) {
  try {
    const response = yield call(api.uploadPropertyBag, action.propertyBag, action.environment);
    yield put({ type: types.UPLOAD_PROPERTY_BAG_SUCCESS, response });
  } catch (error) {
    yield put(createErrorMessageAction(types.UPLOAD_PROPERTY_BAG_ERROR, error));
  }
}
